module.exports = __webpack_public_path__ + "static/img/web2.54638075.png";